import React from "react"
import {useModal, useProgress, useLocal, useUrlQueryComponent} from "../AppContext"
import {Button, ButtonShy} from "./Button"
import {iconCheckmark2, iconList, iconPlus} from "../Helper/Icons"
import style from "./MenuBottom.css"

export const MenuBottom = () => {
    const progress = useProgress()
    const local = useLocal()
    const modal = useModal()
    const urlQueryComponent = useUrlQueryComponent()

    const prev = () => {
        progress.prev()
    }

    const next = () => {
        progress.next()
    }

    const openSolutionProductAdd = () => {
        modal.openSolutionProductAdd()
    }

    const openSolutionProducts = () => {
        modal.openSolutionProducts()
    }

    const isRequestQuoteDisplayed = urlQueryComponent.isContentDisplayed('requestQuote')
    const reviewButtonLabel = isRequestQuoteDisplayed ? 'Angebot anfordern' : 'Planung abschließen'
    const openReview = () => {
        if (isRequestQuoteDisplayed) {
            modal.openRequestQuote()
        } else {
            modal.openSolutionReview()
        }
    }

    if (progress.isRoom()) return null

    if (progress.isSolution()) {
        return <div className={style.container}>
            <div>
                <ButtonShy onClick={prev}>{local.__("Zurück")}</ButtonShy>
                <Button className="review_exit" onClick={openReview}>{iconCheckmark2}{local.__(reviewButtonLabel)}</Button>
            </div>
            <div>
                <ButtonShy onClick={openSolutionProducts}>{iconList}{local.__("Absorber im Projektraum")}</ButtonShy>
                <Button onClick={openSolutionProductAdd}>{iconPlus}{local.__("Absorber hinzufügen")}</Button>
            </div>
            <div>
                <Button className="review_exit" onClick={openReview}>{iconCheckmark2}{local.__(reviewButtonLabel)}</Button>
            </div>
            <div/>
        </div>
    }

    return <div className={style.container}>
        <div>
            <ButtonShy onClick={prev}>{local.__("Zurück")}</ButtonShy>
            <Button onClick={next}>{local.__("nächster Schritt")}</Button>
        </div>
        <div/>
        <div>
            <Button onClick={next}>{local.__("nächster Schritt")}</Button>
        </div>
    </div>
}
